import React, { PropTypes } from 'react';
import { Tabs, Modal, Input, Icon, Button, Upload, message, Spin } from 'antd';
import { hashHistory } from 'react-router';
import DataService from '../../lib/DataService';
import UserRoleStore from '../../stores/UserRoleStore';

const TabPane = Tabs.TabPane;
const { TextArea } = Input;
const confirm = Modal.confirm;

export default class ViewClassesWithNotificationsComponent extends React.Component {
  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: props.currentRole,
      status: props.status, // for reload notifications count by parent component
      schoolId: props.schoolId,
      classes: [],
      spinning: false,
    };
    // bind this
    this.onSelectClass = this.onSelectClass.bind(this);
    this.reloadClassesWithNotifications = this.reloadClassesWithNotifications.bind(this);
    this.onSelectClass = this.onSelectClass.bind(this);
  }

  componentDidMount() {
    this.reloadClassesWithNotifications();
  }

  componentWillReceiveProps() {
    this.reloadClassesWithNotifications();
  }

  reloadClassesWithNotifications() {
    this.setState({
      spinning: true
    });

    DataService.getClassList({ school_id: this.state.schoolId, info: "attendance_task" }).then(response => {
      // classes: grouped by grade number
      let classes = [1, 2, 3, 4, 5].map(gradeNumber => {
        return ({
          gradeNumber: gradeNumber,
          classes: response.filter(c => c.grade_number == gradeNumber)
        });
      }).filter(g => g.classes.length > 0).sort((g1, g2) => g1.gradeNumber - g2.gradeNumber)

      classes.forEach(g => {
        g.gradeName = g.classes[0].grade_name;
      })

      this.setState({
        classes: classes,
        spinning: false
      });
    }, error => {
      console.log(error);
      message.error("加载失败，请稍后重试");
      this.setState({
        spinning: false
      });
    });
  }

  onSelectClass(cid) {
    if (this.props.activeKey) {
      localStorage.setItem('tabKey', this.props.activeKey)
    }
    hashHistory.push(`clock-in/clock-index?classId=${cid}`)
  }

  render() {
    return (
      <div className="view-classes-with-notifications"><Spin spinning={this.state.spinning}>
        {this.state.classes.map(grade => {
          return (
            <div className="view-grade-classes-notifications" key={grade.gradeNumber}>
              <div className="grade-name">{grade.gradeName}</div>
              {grade.classes.map(c => <div className="class-card" key={c.id} onClick={this.onSelectClass.bind(this, c.id)}>
                <div className="class-name">{c.name}</div>
                <div className="notifications-tip">进行中：{c.uncomplete_count}个</div>
                <div className="notifications-tip">已结束：{c.complete_count}个</div>
              </div>)}
            </div>
          )
        })}
      </Spin></div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/clock/ClockClassesListPage.jsx